
import InfoBlock from '../../common/InfoBlock/InfoBlock';
import InfoLine from '../../common/InfoBlock/InfoLine';

export default function ShortUrlInfoBlock(props) {
    return <InfoBlock
        flex="50%"
        marginRight={16}
        label="Detalii Short URL"
        button={{
            link:`/short-urls/${props.shortUrl.id}/edit`,
            label: 'Modifica'
        }}
    >
        <InfoLine label="Id Intern" value={props.shortUrl.id}/>
        <InfoLine label="URL Original" value={props.shortUrl.originalUrl}/>
        <InfoLine label="Cod Scurt" value={props.shortUrl.shortCode}/>
    </InfoBlock>
}
